import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import GrayPanel from '../../components/GrayPanel';
import { formDict } from '../rejestracja/Rejestracja';
import { update_user } from '../../actions/user';
import s from './UserInfo.css';
import v from '../eservices/validators';
import ModalAlert from '../eservices/ModalAlert';
import {
  layoutColorStyle,
  headerStyle,
  getThemeFromLocalStorage,
  TitleDict,
  bodyDict
} from '../../components/utils/utils';
import ModalInfo from '../../components/ModalInfo/ModalInfo';
import waiting from '../eservices/images/waiting-wheel-300x300.gif';
import cloneDeep from 'lodash/cloneDeep';
import Select from 'react-select';

const errorSpanStyle = {
  color: 'red',
  fontSize: '10px',
};

const waitingPlaceholder = (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <img
      src={waiting}// Replace with the URL of your GIF
      alt="Trwa pobieranie danych"
      style={{ marginRight: '8px', width: '24px', height: '24px' }}
    />
    Trwa pobieranie danych...
  </div>
);

const standardPlaceholder = <p style={{ color: 'black' }}>Wybierz...</p>;

const fetchigError = 'Wystąpił błąd pobierania danych adresowych. Spróbuj ponownie później.';
const fetchigErrorTitle = 'Błąd pobierania danych.';

const addressFields = ['AddressCountry', 'AddressVoivodeship', 'AddressPrecint', 'AddressDistrict', 'AddressCity', 'AddressStreet', 'AddressNumber'];

class UserInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: this.props.userData,
      sectionsMap: new Map(),
      isEditingData: true,
      showModal: false,
      showLogoutModal: false,
      response: null,
      badDataReport: [],
      errors: {},
      errorTitle: '',
      errorText: '',
      showError: false,
      colors: 'normal',
      sourceStyle: layoutColorStyle,
      style: {},
      href: null,
      isMounted: false,
      optionsDict: {
        'AddressCountry': [{value: 'Polska', label: 'Polska'}]
      },
      selectedCityHasStreets: false,
      isLoadingData: false,
      actualPopupType: 'privacyPolicy',
      viewPopup: false,
      afterSaving: false,
    };

    this.validators = {
      LastName: [v.NotNull],
      FirstName: [v.NotNull],
      AddressCountry: [v.NotSelected],
      AddressVoivodeship: [v.NotSelected],
      AddressCity: [v.NotSelected],
      AddressDistrict: [v.NotSelected],
      AddressPrecint: [v.NotSelected],
      AddressStreet: [],
      url: [v.checkEpuapAddress],
      // AddressStreet: [v.NotNull],
      AddressNumber: [v.NotSelected],
      AddressMail: [v.NotNull],
      AddressZipCode: [v.NotNull, v.checkZipCode],
      Email: [v.NotNull, v.CheckEmail],
      PhoneNumber: [v.NotNull, v.isNumber],
    };

    this.state.sectionsMap
    .set({ userData: 'Dane użytkownika' }, ['FirstName', 'LastName', 'FullName', 'Pesel', 'username'])
    .set({ epuapData: 'Adres skrytki ePUAP lub adres do doręczeń elektronicznych' }, ['pzEmail', 'pzLogin', 'url', 'e_doreczenia_url'])
    // .set({ userDetails: 'Szczegóły użytkownika' }, ['Pesel', 'UserName'])
    .set({ companyData: 'Dane użytkownika' }, ['CompanyName'])
    .set({ companyDetails: 'Szczegóły użytkownika' }, ['Nip', 'Regon'])
    .set({ adress: 'Dane adresowe' }, ['AddressCountry', 'AddressVoivodeship', 'AddressPrecint', 'AddressDistrict', 'AddressCity', 'AddressStreet', 'AddressNumber', 'AddressFlat', 'AddressZipCode', 'AddressMail'])
    .set({ contactData: 'Dane kontaktowe' }, ['Email', 'PhoneNumber']);

    this.createNewUser.bind(this);
    this.updateThisUser.bind(this);


    this.onChangeDictDict = {
      AddressCountry: {
        onChange: this.onChangeCountry,
      },
      AddressVoivodeship: {
        onChange: this.onChangeVoivodeship,
      },
      AddressPrecint: {
        onChange: this.onChangePrecint,
      },
      AddressDistrict: {
        onChange: this.onChangeDistrict,
      },
      AddressCity: {
        onChange: this.onChangeCity,
      },
      AddressStreet: {
        onChange: this.onChangeStreet,
      },
      AddressNumber: {
        onChange: this.onChangeNumber,
      },
    }
  }

  hidden_fields = ['pzEmail', 'FullName', 'username', 'pzLogin']
  disabled_fields = ['FirstName', 'LastName', 'FullName', 'Pesel', 'username', 'pzLogin', 'AddressZipCode']

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
      display: 'block',
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
        display: 'block',
      };
    }
    if (this.props.userData && !this.props.userData.loginConfirmed){
      const url = new URL(window.location.href);
      const href = url.searchParams.get('href');
      this.setState({
        errorText: 'Twoje konto nie posiada informacji niezbędnych do prawidłowego działania usług. Uzupełnij swój profil użytkowika',
        errorTitle: 'Uwaga!',
        showError: true,
        colors,
        sourceStyle,
        style,
        href,
        isMounted: true,
      });

      return;
    }
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    this.setState({ colors, sourceStyle, style }, () => this.updateValidators(true));
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  updateValidators = (fromMount=false) => {
    if (this.state.userData.addressNotOnList) {
      this.validators.AddressCountry = [v.NotNull];
      this.validators.AddressVoivodeship = [v.NotNull];
      this.validators.AddressCity = [v.NotNull];
      this.validators.AddressDistrict = [v.NotNull];
      this.validators.AddressPrecint = [v.NotNull];
      this.validators.AddressNumber = [v.NotNull];
      this.validate();
    } else {
      this.validators.AddressCountry = [v.NotSelected];
      this.validators.AddressVoivodeship = [v.NotSelected];
      this.validators.AddressCity = [v.NotSelected];
      this.validators.AddressDistrict = [v.NotSelected];
      this.validators.AddressPrecint = [v.NotSelected];
      this.validators.AddressNumber = [v.NotSelected];
      if (!fromMount && !this.state.optionsDict['AddressVoivodeship']) {
        this.setState({ isLoadingData: true }, () => this.fetchVoivodeships(true));
      }
    }

    if (fromMount && !this.state.userData.addressNotOnList) {
      this.fetchVoivodeships();
    } else {
      this.setState({ isMounted: true });
    }
  }

  handleHide = () => {
    this.setState({ viewPopup: false })
  }

  handleBeforeUnload = (e) => {
    const dataChanged = JSON.stringify(this.props.userData) !== JSON.stringify(this.state.userData);
    if (dataChanged && !this.state.afterSaving) {
      e.preventDefault();
      e.returnValue = '';
    }

  };

  handleShow = (popupType) => {
    this.setState({ viewPopup: true, actualPopupType: popupType })
  }

  fetchVoivodeships = (fetchVoivodeshipsOnly=false) => {
    const url = `${process.env.API_URL}/eservices/gugik/voivodeships/`;
    try {
      fetch(url,
        {
          method: 'GET',
        },
        ).then((response) => {
          if (response.status == 200) {
            return response.json();
          } else {
            this.setState({
              errorText: fetchigError,
              errorTitle: fetchigErrorTitle,
              showError: true,
            });
            return;
          }
        }).then((resp) => {
          const voivodeships = resp.voivodeships;
          const voivodeshipsOptions = [];

          Object.entries(voivodeships).forEach(([key, value]) => {
            voivodeshipsOptions.push({ value: value['nazwa'], label: value['nazwa'], id: key });
          });

          const optionsDict = cloneDeep(this.state.optionsDict);
          optionsDict['AddressVoivodeship'] = this.sortOptions(voivodeshipsOptions);

          let voivodeshipID = Object.keys(voivodeships)[0];
          if (this.state.userData.AddressVoivodeship) {
            for (const id of Object.keys(voivodeships)) {
              if (voivodeships[id].nazwa == this.state.userData.AddressVoivodeship) {
                voivodeshipID = id;
                break;
              }
            }
          }
          if (fetchVoivodeshipsOnly) {
            const userData = cloneDeep(this.state.userData);
            userData.AddressVoivodeship = null;
            userData.AddressPrecint = null;
            userData.AddressDistrict = null;
            userData.AddressCity = null;
            userData.AddressStreet = null;
            userData.AddressNumber = null;
            this.setState({ userData, optionsDict, isLoadingData: false }, () => this.validate());
          } else {
            this.setState({ optionsDict }, () => this.fetchCounties(voivodeshipID, true));
          }
          
        })
    } catch (error) {
      this.setState({
        errorText: fetchigError,
        errorTitle: fetchigErrorTitle,
        showError: true,
      });
      return;
    }
  }

  fetchCounties = (voivodeshipID, fromMount=false) => {
    const url = `${process.env.API_URL}/eservices/gugik/counties/${voivodeshipID}/`;
    try {
      fetch(url,
        {
          method: 'GET',
        },
        ).then((response) => {
          if (response.status == 200) {
            return response.json();
          } else {
            this.setState({
              errorText: fetchigError,
              errorTitle: fetchigErrorTitle,
              showError: true,
            });
            return;
          }
        }).then((resp) => {
          const counties = resp.counties;
          const countiesOptions = [];

          Object.entries(counties).forEach(([key, value]) => {
            countiesOptions.push({ value: value['nazwa'], label: value['nazwa'], id: key });
          });

          const optionsDict = cloneDeep(this.state.optionsDict);
          optionsDict['AddressPrecint'] = this.sortOptions(countiesOptions);
          if (fromMount) {
            let countyID = Object.keys(counties)[0];
            const countiesNames = []

            for (const id of Object.keys(counties)) {
              countiesNames.push(counties[id].nazwa)
            }

            if (this.state.userData.AddressPrecint && countiesNames.includes(this.state.userData.AddressPrecint)) {
              for (const id of Object.keys(counties)) {
                if (counties[id].nazwa == this.state.userData.AddressPrecint) {
                  countyID = id;
                  break;
                }
              }
            }
            this.setState({ optionsDict }, () => this.fetchCommunities(countyID, true))
          } else {
            optionsDict['AddressDistrict'] = [];
            optionsDict['AddressCity'] = [];
            optionsDict['AddressStreet'] = [];
            optionsDict['AddressNumber'] = [];
            this.setState({ optionsDict, isLoadingData: false})
          }
          
        })
    } catch (error) {
      this.setState({
        errorText: fetchigError,
        errorTitle: fetchigErrorTitle,
        showError: true,
      });
      return;
    }
  }

  fetchCommunities = (countyID, fromMount=false) => {
    const url = `${process.env.API_URL}/eservices/gugik/communities/${countyID}/`;
    try { 
      fetch(url,
        {
          method: 'GET',
        },
        ).then((response) => {
          if (response.status == 200) {
            return response.json();
          } else {
            this.setState({
              errorText: fetchigError,
              errorTitle: fetchigErrorTitle,
              showError: true,
            });
            return;
          }
        }).then((resp) => {
          const communities = resp.communities;
          const communitiesOptions = [];

          Object.entries(communities).forEach(([key, value]) => {
            communitiesOptions.push({ value: value['nazwa'], label: value['nazwa'], id: key, teryt: value['teryt'] });
          });

          const optionsDict = cloneDeep(this.state.optionsDict);
          optionsDict['AddressDistrict'] = this.sortOptions(communitiesOptions);
          if (fromMount) {
            let communityID = Object.keys(communities)[0];
            let teryt = communities[communityID].teryt
            const communitiesNames = []

            for (const id of Object.keys(communities)) {
              communitiesNames.push(communities[id].nazwa)
            }

            if (this.state.userData.AddressDistrict && communitiesNames.includes(this.state.userData.AddressDistrict)) {
              for (const id of Object.keys(communities)) {
                if (communities[id].nazwa == this.state.userData.AddressDistrict) {
                  communityID = id;
                  teryt = communities[id].teryt
                  break;
                }
              }
            }
            this.setState({ optionsDict }, () => this.fetchCities(communityID, teryt, true))
          } else {
            optionsDict['AddressCity'] = [];
            optionsDict['AddressStreet'] = [];
            optionsDict['AddressNumber'] = [];
            this.setState({ optionsDict, isLoadingData: false})
          }
          
        })
    } catch (error) {
      this.setState({
        errorText: fetchigError,
        errorTitle: fetchigErrorTitle,
        showError: true,
      });
      return;
    }
  }

  fetchCities = (communityID, teryt, fromMount=false) => {
    const url = `${process.env.API_URL}/eservices/gugik/towns/${communityID}/${teryt}/`;
    try {
      fetch(url,
        {
          method: 'GET',
        },
        ).then((response) => {
          if (response.status == 200) {
            return response.json();
          } else {
            this.setState({
              errorText: fetchigError,
              errorTitle: fetchigErrorTitle,
              showError: true,
            });
            return;
          }
        }).then((resp) => {
          const cities = resp.towns;
          const citiesOptions = [];

          Object.entries(cities).forEach(([key, value]) => {
            citiesOptions.push({ value: value['nazwa'], label: value['nazwa'], id: key });
          });

          const optionsDict = cloneDeep(this.state.optionsDict);
          optionsDict['AddressCity'] = this.sortOptions(citiesOptions);
          if (fromMount) {
            let cityID= Object.keys(cities)[0];
            const citiesNames = []

            for (const id of Object.keys(cities)) {
              citiesNames.push(cities[id].nazwa)
            }

            if (this.state.userData.AddressCity && citiesNames.includes(this.state.userData.AddressCity)) {
              for (const id of Object.keys(cities)) {
                if (cities[id].nazwa == this.state.userData.AddressCity) {
                  cityID = id;
                  break;
                }
              }
            }
            if (cityID) {
              this.setState({ optionsDict}, () => this.fetchStreets(cityID, true));
            } else {
              this.setState({ optionsDict, isMounted: true });
            }
            
          } else {
            optionsDict['AddressStreet'] = [];
            optionsDict['AddressNumber'] = [];
            this.setState({ optionsDict, isLoadingData: false})
          }
        })
    } catch (error) {
      this.setState({
        errorText: fetchigError,
        errorTitle: fetchigErrorTitle,
        showError: true,
      });
      return;
    }
  }

  fetchStreets = (cityID, fromMount=false) => {
    const url = `${process.env.API_URL}/eservices/gugik/streets/${cityID}/`;
    try {
      fetch(url,
        {
          method: 'GET',
        },
        ).then((response) => {
          if (response.status == 200) {
            return response.json();
          } else {
            this.setState({
              errorText: fetchigError,
              errorTitle: fetchigErrorTitle,
              showError: true,
            });
            return;
          }
        }).then((resp) => {
          const streets = resp.streets;
          const streetsOptions = [];

          Object.entries(streets).forEach(([key, value]) => {
            streetsOptions.push({ value: value['nazwa'], label: value['nazwa'], id: key });
          });

          const optionsDict = cloneDeep(this.state.optionsDict);
          optionsDict['AddressStreet'] = this.sortOptions(streetsOptions);
          if (fromMount) {
            if (Object.keys(streets).length > 0) {
              let streetID = Object.keys(streets)[0];
              const streetsNames = []

              for (const id of Object.keys(streets)) {
                streetsNames.push(streets[id].nazwa)
              }

              if (this.state.userData.AddressStreet && streetsNames.includes(this.state.userData.AddressStreet)) {
                for (const id of Object.keys(streets)) {
                  if (streets[id].nazwa == this.state.userData.AddressStreet) {
                    streetID = id;
                    break;
                  }
                }
              }

              this.setState({ optionsDict }, () => this.fetchNumbers(streetID, true, false))
            } else {
              this.setState({ optionsDict }, () => this.fetchNumbers(cityID, true, true))
            }
            
          } else {
            optionsDict['AddressNumber'] = [];
            if (Object.keys(streets).length > 0) {
              let streetsHaveNumbers = false
              for (const [key, value] of Object.entries(streets)) {
                const numbersCount = this.getNumbersCountForStreet(key);
                if (numbersCount > 0) {
                  streetsHaveNumbers = true;
                  break;
                }
                if (numbersCount == undefined) break;
              }
              if (streetsHaveNumbers) {
                this.setState({ optionsDict, isLoadingData: false});
              } else {
                this.setState({ optionsDict, isLoadingData: true }, () => this.fetchNumbers(cityID, false, true));
              }
            } else {
              this.setState({ optionsDict, isLoadingData: true }, () => this.fetchNumbers(cityID, false, true));
            }
          }
        })
    } catch (error) {
      this.setState({
        errorText: fetchigError,
        errorTitle: fetchigErrorTitle,
        showError: true,
      });
      return;
    }
  }

  getNumbersCountForStreet = (streetID) => {
    const url = `${process.env.API_URL}/eservices/gugik/addresses/${streetID}/ul/`;
    fetch(url, { method: 'GET' })
    .then((response) => {
      if (response.status == 200) {
        return response.json();
      } else {
        this.setState({
          errorText: fetchigError,
          errorTitle: fetchigErrorTitle,
          showError: true,
        });
        return;
      }
    })
    .then((resp) => {
      if (resp) {
        const addresses = resp.addresses;
        const entries = Object.entries(addresses);
        return entries.length;
      }
    })
    .catch((error) => {
      this.setState({
        errorText: fetchigError,
        errorTitle: fetchigErrorTitle,
        showError: true,
      });
      return;
    });  
  }

  fetchNumbers = (objID, fromMount=false, fromCity=false) => {
    const url = `${process.env.API_URL}/eservices/gugik/addresses/${objID}/${fromCity ? 'miejsc' : 'ul'}/`;
    try {
      fetch(url,
        {
          method: 'GET',
        },
        ).then((response) => {
          if (response.status == 200) {
            return response.json();
          } else {
            this.setState({
              errorText: fetchigError,
              errorTitle: fetchigErrorTitle,
              showError: true,
            });
            return;
          }
        }).then((resp) => {
          const addresses = resp.addresses;
          const addressesOptions = [];

          Object.entries(addresses).forEach(([key, value]) => {
            addressesOptions.push({ value: value['nazwa'], label: value['nazwa'], id: key, postalCode: value['kod_pocztowy'] });
          });

          const optionsDict = cloneDeep(this.state.optionsDict);
          optionsDict['AddressNumber'] = this.sortHouseNumbers(addressesOptions);
          if (fromMount) {
            this.setState({ optionsDict, isMounted: true, isLoadingData: false })
          } else {
            this.setState({ optionsDict, isLoadingData: false})
          }
        })
    } catch (error) {
      this.setState({
        errorText: fetchigError,
        errorTitle: fetchigErrorTitle,
        showError: true,
      });
      return;
    }
  }

  sortOptions = (options) => {
    return options.sort((a, b) => a.label.localeCompare(b.label))
  }

  sortHouseNumbers = (houseNumbers) => {
    const sortedHouseNumbers = houseNumbers.sort((a, b) => {
      const numA = parseInt(a.label, 10);
      const numB = parseInt(b.label, 10);
    
      if (!isNaN(numA) && !isNaN(numB)) {
        // If both are numeric, compare as numbers
        return numA - numB;
      } else {
        // If one or both are alphanumeric, compare as strings
        return a.label.localeCompare(b.label);
      }
    });

    return sortedHouseNumbers;
  }

  onChange = (e, group) => {
    const name = e.target.name;
    const newGroup = {
      ...this.state[group],
      [name]: e.target.value,
    };

    this.setState(
      {
        [group]: newGroup,
      },
      () => this.validate(group, name),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['userData'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  userDataEdit = () => {
    this.setState({
      userData: this.props.userData,
      badDataReport: [],
    }, () => this.validate(null, null, this.fetchVoivodeships()));
  }

  validateBeforeModal = () => {
    this.validate(null, null, this.checkFieldErrors);
  }

  checkFieldErrors = () => {
    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (!this.state.userData.termsOfUseAccepted || !this.state.userData.privacyPolicyAccepted) {
      this.setState({
        errorText: 'Wymagana jest akceptacja regulaminu oraz polityki prywatności.',
        errorTitle: 'Wymagana akceptacja.',
        showError: true,
      });
      return;
    }

    this.showModalAlert();
  }

  showModalAlert = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  }

  changeLocation = () => {
    if (this.state.href) {
      window.location.href = `/logout?href=${encodeURIComponent(this.state.href)}`;
    } else {
      window.location.href = '/logout';
    }
  }

  updateThisUser = () => {
    const data = JSON.stringify(this.state.userData);
    fetch(`${process.env.API_URL}/users/update/${this.state.userData.ID}`,
      {
        method: 'PATCH',
        redirect: 'follow',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: data,
      },
      ).then((response) => {
        if (response.status == 200) {
          this.setState({
            showLogoutModal: true,
            showModal: false,
          }, () => this.afterSaving());
        } else {
          this.setState({
            errorText: 'Wystąpił błąd po stronie serwera. Administrator portalu został poinformowany o zaistniałej sytuacji.',
            errorTitle: 'Błąd zapisu danych.',
            showError: true,
          });
          return;
        }
      });
  
  }

  afterSaving = () => {
    setTimeout(() => {
      this.setState({
        showLogoutModal: false,
        showModal: false,
        afterSaving: true,
      }, () => this.changeLocation())}
      ,5000)
  }


  createNewUser = () => {
    const data = JSON.stringify(this.state.userData);
    const successMessage = 'Zmiany zostały zapisane.';
    fetch(`${process.env.API_URL}/users/create/`,
      {
        method: 'POST',
        redirect: 'follow',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: data,
      },
      ).then((response) => {
        this.setState({
          response: successMessage,
          showModal: false,
        }, () => this.changeLocation());
        if (response.status == 200) {
          this.setState({
            response: successMessage,
            showModal: false,
          }, () => this.changeLocation());
        } else {
          this.setState({
            errorText: 'Wystąpił błąd po stronie serwera. Administrator portalu został poinformowany o zaistniałej sytuacji.',
            errorTitle: 'Błąd zapisu danych.',
            showError: true,
          });
          return;
        }
        
      });
  
  }

  // po kliknieciu przycisku 'Zakmknij' w modalu response
  closeResponseModal = () => {
    this.state.badDataReport.length !== 0 ?
      this.setState({
        response: null,
        showLogoutModal: true,
      })
      :
      this.setState({
        response: null,
        isEditingData: false,
        showLogoutModal: true,
      });
  }

  onHide = () => this.setState({ showError: false });

  onChangeCheckbox = (e, group, state) => {
    const arr = cloneDeep(this.state[group]);

    arr[state] = e.target.checked;
    this.setState({
      [group]: arr,
    }, () => this.updateValidators());
  }
  onChangeCountry = (e) => {
    const AddressCountry = e.value;
    const userData = cloneDeep(this.state.userData);
    userData.AddressCountry = AddressCountry;

    this.setState({userData}, () => this.validate('userData', 'AddressCountry', null))
  }

  onChangeVoivodeship = (e) => {
    const AddressVoivodeship = e.value;
    const userData = cloneDeep(this.state.userData);
    userData.AddressVoivodeship = AddressVoivodeship;
    userData.AddressPrecint = null;
    userData.AddressDistrict = null;
    userData.AddressCity = null;
    userData.AddressStreet = null;
    userData.AddressNumber = null;

    const optionsDict = cloneDeep(this.state.optionsDict);
    optionsDict['AddressPrecint'] = [];
    optionsDict['AddressDistrict'] = [];
    optionsDict['AddressCity'] = [];
    optionsDict['AddressStreet'] = [];
    optionsDict['AddressNumber'] = [];

    const voivodeshipID = e.id;
    this.setState({userData, optionsDict, isLoadingData: true}, () => this.validate('userData', 'AddressVoivodeship', this.fetchCounties(voivodeshipID)))
  }

  onChangePrecint = (e) => {
    const AddressPrecint = e.value;
    const userData = cloneDeep(this.state.userData);
    userData.AddressPrecint = AddressPrecint;
    userData.AddressDistrict = null;
    userData.AddressCity = null;
    userData.AddressStreet = null;
    userData.AddressNumber = null;

    const optionsDict = cloneDeep(this.state.optionsDict);
    optionsDict['AddressDistrict'] = [];
    optionsDict['AddressCity'] = [];
    optionsDict['AddressStreet'] = [];
    optionsDict['AddressNumber'] = [];

    const precintID = e.id;
    this.setState({userData, optionsDict, isLoadingData: true}, () => this.validate('userData', 'AddressPrecint', this.fetchCommunities(precintID)));
  }

  onChangeDistrict = (e) => {
    const AddressDistrict = e.value;
    const userData = cloneDeep(this.state.userData);
    userData.AddressDistrict = AddressDistrict;
    userData.AddressCity = null;
    userData.AddressStreet = null;
    userData.AddressNumber = null;

    const optionsDict = cloneDeep(this.state.optionsDict);
    optionsDict['AddressCity'] = [];
    optionsDict['AddressStreet'] = [];
    optionsDict['AddressNumber'] = [];

    const districtID = e.id;
    const teryt = e.teryt
    this.setState({userData, optionsDict, isLoadingData: true}, () => this.validate('userData', 'AddressDistrict', this.fetchCities(districtID, teryt)));
  }

  onChangeCity = (e) => {
    const AddressCity = e.value;
    const userData = cloneDeep(this.state.userData);
    userData.AddressCity = AddressCity;
    userData.AddressStreet = null;
    userData.AddressNumber = null;

    const optionsDict = cloneDeep(this.state.optionsDict);
    optionsDict['AddressStreet'] = [];
    optionsDict['AddressNumber'] = [];

    const cityID = e.id;
    this.setState({userData, optionsDict, isLoadingData: true}, () => this.validate('userData', 'AddressCity', this.fetchStreets(cityID)));
  }

  onChangeStreet = (e) => {
    const AddressStreet = e.value;
    const userData = cloneDeep(this.state.userData);
    userData.AddressStreet = AddressStreet;
    userData.AddressNumber = null;

    const optionsDict = cloneDeep(this.state.optionsDict);
    optionsDict['AddressNumber'] = [];

    const streetID = e.id;
    this.setState({userData, optionsDict, isLoadingData: true}, () => this.validate('userData', 'AddressStreet', this.fetchNumbers(streetID)));
  }

  onChangeNumber = (e) => {
    const AddressNumber = e.value;
    const userData = cloneDeep(this.state.userData);
    userData.AddressNumber = AddressNumber;
    userData.AddressZipCode = e.postalCode;
    this.setState({userData},() => this.validate('userData', 'AddressNumber'));
  }

  renderField = (key, value) => {
    const Labels = formDict.reduce(
      (res, item) => {
        return ({ ...res, [item.shortName]: {label: item.label, isSelect: item.isSelect ? item.isSelect : false, description: item.description ? item.description : null} });
      }, {},
    );
    // zwraca odpowiednio zablokowane inputy dla danych ktorych nie powinnismy edytowac
    let isError = null;
    this.state.badDataReport.map((v, i) => {
      v === key ? isError = s.error : isError = null;
    });

    const isHidden = this.hidden_fields.indexOf(key) > -1;
    const isDisabled = this.disabled_fields.indexOf(key) > -1;

    return !isHidden ? (
      <div key={key} style={{ marginBottom: Labels[key].description ? '20px' : '0px' }}>
        <div key={key}>
          <div>
            <label id={`user-field-label-${key}`} htmlFor={`user-field-${key}`}>
              {Labels[key].label}
            </label>
          </div>
          <div>
            {(addressFields.includes(key) && this.state.userData.addressNotOnList) || !Labels[key].isSelect ? this.renderInput(key, value) : this.renderSelects(key)}
            {Object.keys(this.state.errors).indexOf(key) > -1 &&
            this.state.errors[key] !== null &&
            this.state.errors[key].length > 0
            ? this.state.errors[key].map((val, index) => (
              <span key={index} style={errorSpanStyle}>
                {val}
              </span>
            ))
            : null}
          </div>
        </div>
        {Labels[key].description ?
          <a
            target={'_blank'}
            href={Labels[key].description.href}
            style={{ marginBottom: '20px' }}
          >
            {Labels[key].description.title}
          </a>
        : null}
      </div>
    ) : null;
  };

  renderInput = (key, value) => {
    let isDisabled = this.disabled_fields.indexOf(key) > -1;
    if (key == 'AddressZipCode' && this.state.userData.addressNotOnList) {
      isDisabled = false;
    }
    return (
      <input
        onChange={(e) => this.onChange(e, 'userData')}
        id={`user-field-${key}`}
        type="text"
        name={key}
        disabled={isDisabled || !this.state.isEditingData}
        className={`form-control ${s.usrVal}`}
        value={value ? value : ''}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(key) > -1 &&
            this.state.errors[key] !== null &&
            this.state.errors[key].length > 0
              ? 'red'
              : '#ccc',
        }}
      />
    );
  }

  renderSelects = (key) => {
    const isDisabled = this.disabled_fields.indexOf(key) > -1;
    const options = this.state.optionsDict[key];
    const margin = '2px 0px 15px 20px';
    return (          
      <Select
        value={this.state.userData[key]}
        onChange={e => this.onChangeDictDict[key].onChange(e)}
        id={`user-field-${key}`}
        disabled={isDisabled || !this.state.isEditingData || this.state.isLoadingData}
        options={options}
        placeholder={this.state.isLoadingData ? waitingPlaceholder : standardPlaceholder}
        noResultsText={'brak wyników'}
        onBlur={event => event.preventDefault()}
        optionClassName="needsclick"
        clearable={false}
        style={{
          width: '100%',
          margin: margin,
          borderColor:
            Object.keys(this.state.errors).indexOf(key) > -1 &&
            this.state.errors[key] !== null &&
            this.state.errors[key].length > 0
              ? 'red'
              : '#ccc',
        }}
        menuContainerStyle={{ margin: margin }}
      />
    );
  }

  renderSection = (title, arr) => {
    const titleText = Object.values(title)[0];
    return (
      <GrayPanel title={titleText} key={Object.keys(title)[0]}>
        {arr.map(
          item => {
            return this.renderField(item, this.state.userData[item]);
          },
        )
        }
        {titleText == 'Dane adresowe' ? 
          <div className={{...s.usrButtons, paddingTop: '0px', paddingBotom: '0px'}}>
            <input
              id={'addressNotOnList'}
              name={'addressNotOnList'}
              type="checkbox"
              value={this.state.userData.addressNotOnList}
              onChange={(e) => this.onChangeCheckbox(e, 'userData', 'addressNotOnList')}
              checked={this.state.userData.addressNotOnList}
              disabled={!this.state.isEditingData}
            />
            <label htmlFor={'addressNotOnList'} style={{ display: 'inline-flex' }}>
              &nbsp;&nbsp;Brak adresu na liście
            </label>
          </div>
        : null}
      </GrayPanel>
    );
  };

  // modal z potwierdzeniem lub odrzuceniem zmian
  modalSeTaki = () => {
    return (
      <div className={s.modal}>
        <div className={s.modal__container} style={this.state.style}>
          <div className={s.modal__header}>Czy na pewno chcesz zapisać zmiany?</div>
          <div className={s.usrButtons}>
            <button onClick={this.showModalAlert} className="btn btn-warning">Anuluj</button>
            <button onClick={this.updateThisUser} className={`btn btn-success ${s.usrButtons__right}`}>Zapisz</button>
          </div>
        </div>
      </div>
    );
  }

  // modal z gif-em w oczekiwaniu na wylogowanie
  logoutWaiting = () => {
    const message = 'Zmiany zostały zapisane. Za chwilę nastąpi wylogowanie.';
    return (
      <div className={s.modal}>
        <div className={s.modal__container} style={{ ...this.state.style, height: '200px' }}>
          <div className={s.modal__header} style={{ height: '150px' }}>
            <img src={waiting} style={{ height: '150px' }} alt="Loader" />
          </div>
          <div className={`${s.usrButtons} ${s.center}`}>
          {message}
          </div>
        </div>
      </div>
    );
  }

  // modal z komunikatem response pod wyslaniu zmian danych uzytkownika
  modalResponse = () => {
    return (
      <div className={s.modal}>
        <div className={s.modal__container} style={this.state.style}>
          <div className={s.modal__header}>{this.state.response}</div>
          <div className={`${s.usrButtons} ${s.center}`}>
            <button onClick={this.closeResponseModal} className="btn btn-success">Zamknij</button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    
    if (this.state.isMounted) {
      const dataChanged = JSON.stringify(this.props.userData) !== JSON.stringify(this.state.userData);
      return (
        <div className={s.usrContainer} style={this.state.style}>
          <div className={s.usrTitle}>Dane:</div>
          {
            [...this.state.sectionsMap].filter(
              ([key, val]) => {
                const sectionKeyKey = Object.keys(key)[0];
                return this.state.userData.IsPerson === true ?
                  !['companyData', 'companyDetails'].includes(sectionKeyKey) :
                  !['userData'].includes(sectionKeyKey);
              },
            ).map(
              ([key, value]) => this.renderSection(key, value),
            )
          }
          <div className={{...s.usrButtons, paddingTop: '0px', paddingBotom: '0px'}}>
            <input
              id={'userData_termsOfUseAccepted'}
              name={'userData_termsOfUseAccepted'}
              type="checkbox"
              value={this.state.userData.termsOfUseAccepted}
              onChange={(e) => this.onChangeCheckbox(e, 'userData', 'termsOfUseAccepted')}
              checked={this.state.userData.termsOfUseAccepted}
              disabled={!this.state.isEditingData}
            />
            <label htmlFor={'userData_termsOfUseAccepted'} style={{ display: 'inline-flex' }}>
              &nbsp;&nbsp;Akceptuję&nbsp;<a id="termsOfUse" href="#" onClick={() => this.handleShow('termsOfUse')}>Regulamin Portalu</a>*
            </label>
          </div>
          <div className={{...s.usrButtons, paddingTop: '0px', paddingBotom: '0px'}}>
            <input
                id={'userData_privacyPolicyAccepted'}
                name={'userData_privacyPolicyAccepted'}
                type="checkbox"
                value={this.state.userData.privacyPolicyAccepted}
                onChange={(e) => this.onChangeCheckbox(e, 'userData', 'privacyPolicyAccepted')}
                checked={this.state.userData.privacyPolicyAccepted}
                disabled={!this.state.isEditingData}
              />
            <label htmlFor={'userData_privacyPolicyAccepted'} style={{ display: 'inline-flex' }}>
              &nbsp;&nbsp;Akceptuję&nbsp;<a id="privacyPolicy" href="#" onClick={() => this.handleShow('privacyPolicy')}>Politykę Prywatności</a>*
            </label>
          </div>
          <div className={s.usrButtons}>
            <p>* - pole obowiązkowe</p>
          </div>
          <div className={s.usrButtons}>
            {dataChanged ? 
             <button onClick={this.userDataEdit} className="btn btn-primary">Anuluj edycję</button>
            : null }
            {dataChanged ?
              <button onClick={this.validateBeforeModal} className="btn btn-success">Zapisz zmiany</button>
              :
              null
            }
          </div>
          <ModalAlert
            title={this.state.errorTitle}
            bodyText={this.state.errorText}
            show={this.state.showError}
            name="errorModal"
            onHide={this.onHide}
          />
          {this.state.showModal ? this.modalSeTaki() : null}
          {this.state.showLogoutModal ? this.logoutWaiting() : null}
          {this.state.response !== null ? this.modalResponse() : null}

          <ModalInfo
            title={TitleDict[this.state.actualPopupType]}
            bodyText={bodyDict[this.state.actualPopupType]}
            show={this.state.viewPopup}
            name="viewPopupModal"
            onSave={this.handleHide}
            colors={this.state.colors}
            onHide={this.handleHide}
          />
        </div>
      );
    } 

    return (
      <GrayPanel
        title="Trwa ładowanie zawartości..."
        bodyStyle={{ textAlign: 'center !important', marginTop: '100px', marginBottom: '100px' }}
      >
        <img alt="Loader" src={waiting} />
    </GrayPanel>
    )
  }

}

const mapState = (state) => ({});

const mapDispatch = {
  update_user,
};

export default withStyles(s)(connect(mapState, mapDispatch)(UserInfo));




// WEBPACK FOOTER //
// src/routes/userInfo/UserInfo.js